import React from "react";

import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import {FilePresent} from "@vedmarket/ui-kit";

import {COLORS} from "../../../../../../../../../config/constants";

import './support-request-attachments.scss'

type Props = {
  attachments?: SupportTicketAttachment[]
}

const SupportRequestAttachments = ({attachments}: Props) => {

  if (!attachments?.length) {
    return null;
  }

  return (
    <div className='support-request-attachments'>
      {attachments.map((attachment) => (
        <Link
          key={attachment.id}
          href={attachment.file}
          target='_blank'
          rel='noreferrer'
          underline='hover'
          className='support-request-attachments__link'
          sx={{color: COLORS.BLUE, cursor: 'pointer'}}
        >
          <FilePresent className='support-request-attachments__icon' />
          <Typography
            component='span'
            variant='body2'
            className='support-request-attachments__title'
            sx={{color: 'inherit', letterSpacing: 0, lineHeight: '20px'}}
          >
            {attachment.title}
          </Typography>
        </Link>
      ))}
    </div>
  );
};

export default SupportRequestAttachments;
